/* eslint-disable import/no-import-module-exports */
// import { routerMiddleware } from 'connected-react-router';
import { Middleware, Store } from 'redux';
import { createLogger } from 'redux-logger';
import { History } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import { routerHistory } from '@universal/lib/routerHistory';
import { rootReducer } from './index';

// Exports
/**
 * Create redux store with initial state
 *
 * @param {{}} preloadedState
 * @param {Middleware[]} extraMiddleware environment-specific middleware (the client passes its epic middleware)
 * @returns {{ store: Store, history: History }}
 */
export const createStore = (
  preloadedState = {},
  extraMiddleware: Middleware[] = [],
): { store: Store; history: History } => {
  // Create middlewares
  const middleware = [
    ...[
      // connected-react-router
      // routerMiddleware(routerHistory),

      // Environment-specific (the client's redux-observable epic middleware)
      ...extraMiddleware,

      /*
       * Development only middlewares
       */

      // Logging
      process.env.NODE_ENV !== 'production' &&
        createLogger({
          collapsed: (_, action, logEntry) =>
            (!logEntry || !logEntry.error) && !action.error && !(action.payload instanceof Error),
        }),
    ].filter(Boolean),
  ];

  // Create store
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
  });

  // Enable hot reloading
  if (module.hot) {
    module.hot.accept('./index', () => {
      store.replaceReducer(rootReducer);
    });
  }

  return { store, history: routerHistory };
};
